import { MouseEventHandler } from 'react'
import { CaptureWithContext, Metadata } from '.'

const EVENT_CATEGORY = 'button'
const BUTTON_CLICKED = 'button_clicked'

export const trackButtonClick =
  (capture: CaptureWithContext) =>
  (metadata: Metadata): void => {
    capture(BUTTON_CLICKED, {
      ...metadata,
      category: EVENT_CATEGORY,
    })
  }

export const trackButtonClickEvent =
  (capture: CaptureWithContext) =>
  (
    metadata: Metadata,
    onClick?: MouseEventHandler | ((event?: unknown) => Promise<void>),
  ) =>
  (event: React.MouseEvent<Element>) => {
    trackButtonClick(capture)(metadata)
    void onClick?.(event)
  }
